<!-- Renamed from OfferImageCarousel.svelte -->
<script lang="ts">
  import type { ManageAPI } from "~/manage-api/types";

  export let offer: ManageAPI.Offer;
  export let storeLogo = "";

  $: imageUrl = offer.images?.[0] || storeLogo;
</script>

<div class="offer-card-image">
  <img 
    alt={offer.title} 
    src={imageUrl} 
    class="lazy-loading-src" 
  />
</div>

<style lang="scss">
  .offer-card-image {
    width: 100%;
    aspect-ratio: 1 / 1;
    background-color: #fff;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border: 3px solid var(--color-accent-secondary-light);
    }
  }
</style> 